import { Box, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { useState } from 'react';
import type { IContainerChildrenProps } from 'utils/IContainerChildrenProps';

type CollapsibleProps = {
  collapsed?: boolean;
  title: string;
  itemCount?: number | string;
};
export const Collapsible: FC<CollapsibleProps & IContainerChildrenProps> = ({
  title,
  collapsed = true,
  itemCount,
  children
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  return (
    <Box width="full" mb="xs">
      <FlexLayout
        justifyContent="space-between"
        alignItems="center"
        p="xs"
        css={{
          cursor: 'pointer',
          borderBottom: !isCollapsed ? '1px solid #dfe1e6' : 'none'
        }}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <H4 color="primaryText" fontSize={'llg' as any} style={{ textTransform: 'capitalize' }}>
          {title}
        </H4>
        <FlexLayout alignItems="center">
          <H4 color="secondary">{itemCount}</H4>
          <Icon src={isCollapsed ? 'unfoldMoreRounded' : 'unfoldLessRounded'} stroke="transparent" color="secondary" />
        </FlexLayout>
      </FlexLayout>
      <Box
        css={{
          overflowY: isCollapsed ? 'hidden' : 'visible',
          height: isCollapsed ? 0 : 'auto'
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
